import { DetailPageTopBarRightElement } from "./TopBar.styles";
import { memo } from "react";

/**
 * DetailPageTopBarRight
 *
 * Wraps the right‑aligned content inside a detail‑page top bar using
 * `DetailPageTopBarRightElement`, memoised to avoid redundant re‑renders.
 *
 * Props
 * - children (React.ReactNode): elements to display inside the right section
 * - …rest (HTMLAttributes<HTMLDivElement>): additional props applied to the container
 */

export const DetailPageTopBarRight = memo(({ children, ...rest }) => {
  return <DetailPageTopBarRightElement {...rest}>{children}</DetailPageTopBarRightElement>;
});
